import React, { Component } from 'react'
import Dialog from "./../../../../../components/dialog-base"
import './styles.scss'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'


interface IPostsNumbersProps {
    onClose: () => void
    item: {
        id: string,
        img: string,
        name: string,
        price: number,
        size: string,
        type: number
    }
}

class PostsNumbersPopUp extends React.Component<IPostsNumbersProps & ReturnType<typeof storesToProps>> {
    public state = {
        startFlat: 1,
        endFlat: 1
    }


    public minusStartFlat = () => {
        if (this.state.startFlat > 1) {
            this.setState({ startFlat: this.state.startFlat - 1 })
        }
    }
    public minusEndFlat = () => {
        if (this.state.endFlat > 1 && this.state.endFlat > this.state.startFlat) {
            this.setState({ endFlat: this.state.endFlat - 1 })
        }
    }

    public plusStartFlat = () => {
        if (this.state.endFlat > this.state.startFlat) {
            this.setState({ startFlat: this.state.startFlat + 1 })
        } else {
            this.setState({ startFlat: this.state.startFlat + 1, endFlat: this.state.startFlat + 1 })
        }
    }
    public plusEndFlat = () => {
        this.setState({ endFlat: this.state.endFlat + 1 })
    }

    public get allCount() {
        return this.state.endFlat - this.state.startFlat + 1
    }

    public onAddProduct = () => {
        const { addProduct } = this.props.busket
        const { startFlat, endFlat } = this.state
        const descriptions = `c ${startFlat} по ${endFlat}`
        addProduct(this.props.item, this.allCount, this.state.startFlat, this.state.endFlat, descriptions)
        this.props.onClose()
    }

    public nameOfItem =() =>{
        switch(this.props.item.type){
            case 48:
                return "Парковочные места";
            case 81:
                return "Квартиры";
            case 51:
                return "Квартиры"
        }
    }


    render() {
        const { startFlat, endFlat} = this.state

        return <Dialog onClose={this.props.onClose}>
            <div className="floors_number_container">
                <img className="dialogClose" onClick={this.props.onClose} src="/local/templates/sign_plus/images/close.svg" alt="" />
                <div className="dialogContaine__inner">
                    <div className="title">
                    {this.props.item.name}
                </div>
                    <div className="top_block">
                        <img className={this.props.item.type === 39 ? "big_picture" : "small_picture"} src={this.props.item.img} />
                        <div className="title">{ this.nameOfItem()}</div>
                        <div className="numbers">
                            <div className="with">c</div>
                            <div className='swither_container'>
                                <div className="minus" onClick={this.minusStartFlat}>-</div>
                                <div className="count">{startFlat}</div>
                                <div className="plus" onClick={this.plusStartFlat}>+</div>
                            </div>
                            <div className="on">по</div> <div className="minus" onClick={this.minusEndFlat}>-</div>
                            <div className="count">{endFlat}</div>
                            <div className="plus" onClick={this.plusEndFlat}>+</div>
                        </div>
                    </div>
                    <div className="bottom_block">
                        <div className="price">{this.props.item.price} руб/шт</div>
                        <div className="count">{this.allCount} шт</div>
                        <div className="allPrice">{this.allCount * this.props.item.price} руб</div>
                    </div>
                    <div className="inBusker" onClick={this.onAddProduct}>В корзину</div>
                </div>

            </div>
        </Dialog>
    }
}

const storesToProps = ({ store }: IStoresMap, _nextProps: any ) => ({
    busket: store.BusketStore
})

export default connector(storesToProps)(PostsNumbersPopUp)
